export class Session{
	$key: string;
	admin: string;
	admin_uid: string;
	currentQuestion: string;
	isActive: boolean;
	isQuestionsActive: boolean;
	location: string;
	sessionName: string;
}